/**
 * Created by olga on 05.02.2025
 */

const BorderRenderer = {
    place: function (area, imagePlacement, options) {
        options = options || {};

        if (area[0] && area[0].x !== undefined) {
            area = BorderRenderer.createAreaMap(area);
        }

        const iterator = function (x, y) {
            if (!area[y] || !area[y][x]) {
                return;
            }

            const borders = BorderRenderer.getBorders(x, y, area);
            imagePlacement(borders, cc.p(x, y), options);
        };

        if (options.part) {
            options.part.forEach((cell) => {
                iterator(cell.x, cell.y);
            });
        } else {
            BorderRenderer.iterateMap2d(area, iterator);
        }
    },

    createAreaMap: function (positions) {
        const areaMap = [];
        positions.forEach((pos) => {
            areaMap[pos.y] = areaMap[pos.y] || [];
            areaMap[pos.y][pos.x] = true;
        });

        return areaMap;
    },

    getBorders: function (x, y, area) {
        return Object.keys(BorderRenderer.BORDERS).filter((name) => {
            const border = BorderRenderer.BORDERS[name];
            if (border.isNeighbor && !border.isNeighbor.every((dir) => {
                const neighbor = BorderRenderer.getNeighbor(x, y, dir);
                return area[neighbor.y] && area[neighbor.y][neighbor.x];
            })) {
                return false;
            }

            if (border.noNeighbor && border.noNeighbor.some((dir) => {
                const neighbor = BorderRenderer.getNeighbor(x, y, dir);
                return area[neighbor.y] && area[neighbor.y][neighbor.x];
            })) {
                return false;
            }

            return true;
        }).map((name) => ({
            name,
            isNeighbor: BorderRenderer.BORDERS[name].isNeighbor,
            noNeighbor: BorderRenderer.BORDERS[name].noNeighbor,
            borderCell: BorderRenderer.getNeighbor(x, y, BorderRenderer.BORDERS[name].direction)
        }));
    },

    getNeighbor: function (x, y, direction) {
        const dir = BorderRenderer.DIRS[direction];
        return cc.p(x + dir.x, y + dir.y);
    },

    getNeighbours: function (x, y) {
        return Object.keys(BorderRenderer.DIRS).map((dir) => BorderRenderer.getNeighbor(x, y, dir));
    },

    iterateMap2d: function (array2d, iterator) {
        array2d.forEach((row, y) => {
            row.forEach((cell, x) => {
                if (cell) {
                    iterator(x, y);
                }
            });
        });
    },

    isSide: function (borderName) {
        return ["down", "left", "up", "right"].includes(borderName);
    },

    isOutCorner: function (borderName) {
        return ["up_right", "up_left", "down_right", "down_left"].includes(borderName);
    },

    isInnerCorner: function (borderName) {
        return ["inner_up_right", "inner_up_left", "inner_down_right", "inner_down_left"].includes(borderName);
    }
};

BorderRenderer.DIRS = {
    up: { y: -1, x: 0 },
    right: { y: 0, x: 1 },
    down: { y: 1, x: 0 },
    left: { y: 0, x: -1 },
    up_right: { y: -1, x: 1 },
    up_left: { y: -1, x: -1 },
    down_right: { y: 1, x: 1 },
    down_left: { y: 1, x: -1 }
};

BorderRenderer.BORDERS = {
    up: { noNeighbor: ["up"], direction: "up" },
    right: { noNeighbor: ["right"], direction: "right" },
    left: { noNeighbor: ["left"], direction: "left" },
    down: { noNeighbor: ["down"], direction: "down" },

    up_left: { noNeighbor: ["up", "left", "up_left"], direction: "up_left" },
    up_right: { noNeighbor: ["up", "right", "up_right"], direction: "up_right" },
    down_left: { noNeighbor: ["down", "left", "down_left"], direction: "down_left" },
    down_right: { noNeighbor: ["down", "right", "down_right"], direction: "down_right" },

    inner_up_left: { noNeighbor: ["up"], isNeighbor: ["up_left"], direction: "up" },
    inner_up_right: { noNeighbor: ["up"], isNeighbor: ["up_right"], direction: "up" },
    inner_down_left: { noNeighbor: ["down"], isNeighbor: ["down_left"], direction: "down" },
    inner_down_right: { noNeighbor: ["down"], isNeighbor: ["down_right"], direction: "down" }
};

// corners types:  https://gyazo.com/f801034658bc513c86021e831a15a6e9
